import React, { useState, useEffect } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import ImagemPadrao from "../../../../assets/no_image.jpg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Skeleton from "react-loading-skeleton";
import { Modal, Button } from "react-bootstrap";
import "../../../../scss/visitante/item.scss";

export default function Item() {
  const { get } = useFetch();
  let location = useLocation();
  let { id } = useParams();

  const defaultState = {
    loading: true,
    item: {
      id_item: "",
      nome_item: "",
      apresentacao: "",
      material: "",
      altura: "",
      largura: "",
      comprimento: "",
      diametro: "",
      profundidade: "",
      peso: "",
      circunferencia: "",
      forma_aquis: "",
      dt_entrada: "",
      dt_saida: "",
      marcas: "",
      procedencia: "",
      origem: "",
      fabricante: "",
      conservacao: "",
      restauracao: "",
      n_patrimonial: "",
      pesquisa: "",
      solicitacao: "",
      bibliografia: "",
      historico: "",
      observacao: "",
      decada_fabricacao: "",
      ano_fabricacao: "",
      Localizacao: {},
      id_localizacao: "",
      exposicao: "",
      status_item: "",
    },
    categoriasSelecionadas: [],
    palavras: [],
    fotosHistoricas: { salvas: [] },
    fotosDescritivas: { salvas: [] },
    localizacao: { sala: "", estante: "", prateleira: "" },
  };

  const [state, setState] = useState(() => {
    if (location.state && location.state.acao) {
      defaultState.acao = location.state.acao;
    }
    return defaultState;
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  // Zoom/arrastar da lightbox — mesmo padrão (sem lib externa, só transform
  // + state) já usado e funcionando em IconografiaDetalhe.js.
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      let item = await buscarItem(id);
      let localizacao = item.Localizacao || defaultState.localizacao;
      
      let categoriasSelecionadas = [];
      if (item.CategoriaFuncionals && item.CategoriaFuncionals.length > 0) {
        categoriasSelecionadas = item.CategoriaFuncionals.map(element => ({
          value: element.id_categoria,
          label: element.nome_cat,
        }));
      }

      let palavras = [];
      if (item.PalavraChaves && item.PalavraChaves.length > 0) {
        palavras = item.PalavraChaves.map(element => ({
          value: element.sec_palavra,
          label: element.palavra,
        }));
      }

      let fotosDescritivas = { salvas: [] };
      if (item.FotoDescritivas && item.FotoDescritivas.length > 0) {
        fotosDescritivas.salvas = item.FotoDescritivas.map(foto => foto.base64);
      }

      let fotosHistoricas = { salvas: [] };
      if (item.FotoHistoricas && item.FotoHistoricas.length > 0) {
        fotosHistoricas.salvas = item.FotoHistoricas.map(foto => [
          foto.base64,
          foto.descricao || ""
        ]);
      }

      setState({
        ...state,
        loading: false,
        item,
        categoriasSelecionadas,
        fotosDescritivas,
        fotosHistoricas,
        localizacao,
        palavras,
      });
    };
    fetchData();
  }, [id]);

  async function buscarItem(id) {
    try {
      let response = await get("/item/" + id);
      if (response.status === 200) {
        return response.result.data || defaultState.item;
      }
      return defaultState.item;
    } catch (error) {
      console.error("Erro no buscarItem():", error);
      return defaultState.item;
    }
  }

  function getCategoriasFormatadas(categoriasSelecionadas) {
    if (state.loading) return <Skeleton width={200} />;
    if (!categoriasSelecionadas?.length) return "Nenhuma categoria selecionada";
    return categoriasSelecionadas.map(categoria => categoria.label).join(", ");
  }

  function getPalavrasFormatadas(palavras) {
    if (state.loading) return <Skeleton width={300} />;
    if (!palavras?.length) return "Nenhuma palavra chave";
    const palavrasValidas = palavras.map(p => p.label).filter(label => label?.trim());
    return palavrasValidas.length ? palavrasValidas.join(", ") : "Nenhuma palavra chave";
  }

  function getDimensoesFormatadas(item) {
    if (state.loading) return <Skeleton width={300} />;
    
    const dimensoes = [];
    if (item.altura) dimensoes.push(`Altura: ${item.altura} cm`);
    if (item.largura) dimensoes.push(`Largura: ${item.largura} cm`);
    if (item.comprimento) dimensoes.push(`Comprimento: ${item.comprimento} cm`);
    if (item.diametro) dimensoes.push(`Diâmetro: ${item.diametro} cm`);
    if (item.profundidade) dimensoes.push(`Profundidade: ${item.profundidade} cm`);
    if (item.peso) dimensoes.push(`Peso: ${item.peso}`);
    if (item.circunferencia) dimensoes.push(`Circunferência: ${item.circunferencia} cm`);
    
    return dimensoes.length > 0 ? dimensoes.join('; ') : 'Dimensões não informadas';
  }


  const openModal = (image) => {
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const resetZoom = () => { setZoom(1); setPosition({ x: 0, y: 0 }); };
  const closeModal = () => { setModalIsOpen(false); resetZoom(); };

  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      setStartPos({ x: e.clientX - position.x, y: e.clientY - position.y });
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const nextX = e.clientX - startPos.x;
    const nextY = e.clientY - startPos.y;
    const containerWidth = e.currentTarget.offsetWidth;
    const containerHeight = e.currentTarget.offsetHeight;
    const maxX = Math.max(0, (containerWidth * zoom - containerWidth) / 2);
    const maxY = Math.max(0, (containerHeight * zoom - containerHeight) / 2);
    setPosition({
      x: Math.max(-maxX, Math.min(nextX, maxX)),
      y: Math.max(-maxY, Math.min(nextY, maxY))
    });
  };

  const stopDragging = () => setIsDragging(false);
  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.5, 4));
  const handleZoomOut = () => {
    setZoom(prev => {
      const newZoom = Math.max(prev - 0.5, 1);
      if (newZoom === 1) setPosition({ x: 0, y: 0 });
      return newZoom;
    });
  };

  const formatarData = (dataString) => {
    if (!dataString) return null;
    return dataString.split('-').reverse().join('/');
  };

  // Se não encontrar o item
  if (!state.item.id_item && !state.loading) {
    return (
      <div className="artifact-detail">
        <div className="container">
          <div className="back-button">
            <Link to="/acervo" className="btn-voltar">
              <FontAwesomeIcon icon={faAngleLeft} className="icon" />
              <span>Voltar ao Acervo</span>
            </Link>
          </div>
          <h1 className="text-center">Item não encontrado</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="artifact-detail">
      <div className="container">
        {/* Botão Voltar */}
        <div className="back-button">
          <Link to="/acervo" className="btn-voltar">
            <FontAwesomeIcon icon={faAngleLeft} className="icon" />
            <span>Voltar à página anterior</span>
          </Link>
        </div>

        {/* Título da Seção */}
        <div className="section-title">
          <div className="title-line"></div>
          <h1>Detalhes do item</h1>
        </div>

        {/* Seção Principal */}
        <div className="main-section">
          {/* Carrossel de Fotos Descritivas */}
          <div className="image-section">
            {state.loading ? (
              <Skeleton height={500} />
            ) : state.fotosDescritivas.salvas.length > 0 ? (
              <Carousel 
                className="main-carousel"
                onClickItem={(index) => openModal(state.fotosDescritivas.salvas[index])}
              >
                {state.fotosDescritivas.salvas.map((foto, index) => (
                  <div key={index} className="carousel-slide">
                    <img
                      src={`data:image/jpeg;base64,${foto}`}
                      alt={`${state.item.nome_item} - Foto ${index + 1}`}
                      className="responsive-image"
                    />
                  </div>
                ))}
              </Carousel>
            ) : (
              <div className="no-image full-space">
                <img src={ImagemPadrao} alt="Imagem padrão" />
              </div>
            )}
          </div>

          {/* Informações Básicas */}
          <div className="basic-info">
            <h2>
              {state.loading ? <Skeleton width={200} /> : state.item.nome_item}
            </h2>
            <p className="presentation">
              {state.loading ? <Skeleton count={2} /> : state.item.apresentacao}
            </p>

            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Procedência</span>
                <strong>
                  {state.loading ? <Skeleton width={300} /> : state.item.procedencia}
                </strong>
              </div>
              <div className="info-item">
                <span className="info-label">Palavras Chaves</span>
                <strong>{getPalavrasFormatadas(state.palavras)}</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Seção de Observações e Fotos Históricas */}
        <div className="secondary-section">
          <div className="text-content">
            <div className="content-block">
              <div className="block-header">
                <div className="block-line"></div>
                <h3>Observações</h3>
              </div>
              <p>
                {state.loading ? <Skeleton count={2} /> : state.item.observacao}
              </p>
            </div>

            <div className="content-block">
              <div className="block-header">
                <div className="block-line"></div>
                <h3>Histórico</h3>
              </div>
              <p>
                {state.loading ? <Skeleton count={2} /> : state.item.historico}
              </p>
            </div>
          </div>

          {/* Fotos Históricas */}
          <div className="historical-photos">
            {state.loading ? (
              <Skeleton height={500} />
            ) : state.fotosHistoricas.salvas.length > 0 ? (
              <Carousel 
                className="historical-carousel"
                onClickItem={(index) => openModal(state.fotosHistoricas.salvas[index][0])}
              >
                {state.fotosHistoricas.salvas.map((foto, index) => (
                  <div key={index} className="carousel-slide">
                    <img
                      src={`data:image/jpeg;base64,${foto[0]}`}
                      alt={`Foto histórica ${index + 1}`}
                      className="responsive-image"
                    />
                    <p className="photo-description">{foto[1]}</p>
                  </div>
                ))}
              </Carousel>
            ) : (
              <div className="no-image full-space">
                <img src={ImagemPadrao} alt="Nenhuma foto histórica disponível" />
              </div>
            )}
          </div>
        </div>

        {/* Informações Detalhadas */}
        <div className="detailed-info">
          <h3>Informações Detalhadas</h3>
          <div className="info-grid-detailed">
            <div className="info-item-detailed">
              <span className="info-label">Número patrimonial</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.n_patrimonial}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Localização</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : 
                 state.localizacao.sala ? 
                 `${state.localizacao.sala} ${state.localizacao.estante} ${state.localizacao.prateleira}` : 
                 "Não especificada"}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Forma de aquisição</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.forma_aquis}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Data de entrada</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : formatarData(state.item.dt_entrada)}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Ano de fabricação</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.ano_fabricacao}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Década de fabricação</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.decada_fabricacao}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Fabricante</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.fabricante}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Material</span>
              <strong>
                {state.loading ? <Skeleton width={200} /> : state.item.material}
              </strong>
            </div>
            <div className="info-item-detailed full-width">
              <span className="info-label">Dimensões</span>
              <strong>
                {getDimensoesFormatadas(state.item)}
              </strong>
            </div>
            <div className="info-item-detailed full-width">
              <span className="info-label">Bibliografia</span>
              <strong>
                {state.loading ? <Skeleton width={300} /> : state.item.bibliografia}
              </strong>
            </div>
            <div className="info-item-detailed">
              <span className="info-label">Categoria</span>
              <strong>{getCategoriasFormatadas(state.categoriasSelecionadas)}</strong>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox com zoom/arrastar — mesmo padrão de IconografiaDetalhe.js.
          O modal antigo (Modal.Header/Body padrão + <img className="modal-image">
          sem nenhuma regra CSS correspondente) deixava a imagem sem
          width/height/object-fit definidos, renderizando distorcida/cortada. */}
      <Modal show={modalIsOpen} onHide={closeModal} size="xl" centered contentClassName="bg-transparent border-0 shadow-none" className="photo-lightbox">
        <div className="d-flex justify-content-between align-items-center p-3">
          <div className="d-flex gap-2">
            <Button variant="light" onClick={handleZoomOut} className="rounded-circle shadow-sm" style={{ width: '40px', height: '40px' }}>-</Button>
            <Button variant="light" onClick={handleZoomIn} className="rounded-circle shadow-sm" style={{ width: '40px', height: '40px' }}>+</Button>
            <Button variant="light" onClick={resetZoom} className="rounded-pill px-3 shadow-sm">Resetar</Button>
          </div>
          <button onClick={closeModal} className="btn-close btn-close-white shadow-none"></button>
        </div>
        <Modal.Body className="p-0 text-center" style={{ overflow: 'hidden', maxHeight: '85vh', cursor: zoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default' }}
          onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={stopDragging} onMouseLeave={stopDragging}>
          {/* Sem width:100% fixo no wrapper/imagem: numa foto retrato (mais
              alta que larga), forçar width:100% deixava a altura maior que o
              modal (max-height:85vh + overflow:hidden), cortando a imagem em
              cima/embaixo. Com maxWidth/maxHeight no <img> (mantendo
              proporção), encaixa inteiro tanto retrato quanto paisagem. */}
          <div style={{ transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`, transition: isDragging ? 'none' : 'transform 0.3s ease', display: 'inline-block' }}>
            <img
              src={`data:image/jpeg;base64,${selectedImage}`}
              alt="Imagem ampliada"
              className="rounded shadow-lg"
              draggable="false"
              style={{ maxWidth: '90vw', maxHeight: '85vh', width: 'auto', height: 'auto', objectFit: 'contain' }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}